import { BaseError } from './base';

type DeeplinkConnectAndVerifyUnsupportedErrorParams = {
  walletProviderKey: string;
};

export class DeeplinkConnectAndVerifyUnsupportedError extends BaseError {
  constructor({
    walletProviderKey,
  }: DeeplinkConnectAndVerifyUnsupportedErrorParams) {
    super({
      cause: null,
      code: 'deeplink_connect_and_verify_unsupported',
      docsUrl: null,
      metaMessages: [
        `Wallet provider key: ${walletProviderKey}`,
        'On mobile, deep link wallet providers (e.g. Phantom redirect) cannot connect and verify in a single step.',
        'iOS does not allow two sequential deep links — the second one is silently ignored because it is no longer tied to a user gesture.',
        'Android may handle sequential deep links differently, but this guard applies to all mobile platforms to ensure a stable experience and prevent production-only errors.',
        'Use connectWithWalletProvider() first, then call verifyWalletAccount() from a separate user action (e.g. a "Verify Ownership" button).',
      ],
      name: 'DeeplinkConnectAndVerifyUnsupportedError',
      shortMessage:
        'connectAndVerifyWithWalletProvider is not supported for deep link wallet providers on mobile. Use connectWithWalletProvider and verifyWalletAccount separately.',
    });
  }
}
